module.exports = __webpack_public_path__ + "img/Mask Group 8.77fde04a.svg";